import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user :{
      _id:"",
      email: "",
      name:""
  }
};

export const userSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    initCurrentUser:(state, action)=>{
      state.user = action.payload
    },
    },
});
export const { initCurrentUser} = userSlice.actions;

export default userSlice.reducer;
